import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
    ...zhLocale,
    list: {
        return: '返回',
        download: '下载',
        pass: '放行',
        rawdata: '原始邮件',
        header: '信头',
        whyspam: '原因分析',
        show: '显示摘要',
        body: '正文分析',
        origin: '原始正文',
        info: '分词信息',
        trainspam: '垃圾训练',
        trainnormal: '正常训练',
        cancel_send: '取消发送',
        immediate_delivery: '立即投递',
        bath_send: '批量发送',
        cc: '抄送',
        detail: '详细信息',


        // 查找条件
        from: '来自',
        to: '发给',
        data: '日期',
        record_time: "记录时间",
        attach: '附件',
        envfrom: '信封发件人',
        envrcpt: '信封收件人',
        id: '消息ID',
        ip: '对方IP',
        replyto: 'replyto',
        hide: '隐藏',
        num: '个',
        bte: 'Email加黑名单',
        wte: 'Email加白名单',
        wte1: '将Email移出白名单',
        bte1: '将Email移出黑名单',
        bti: 'ip加黑名单',
        wti: 'ip加白名单',
        bti1: '将ip移出黑名单',
        wti1: '将ip移出白名单',
        fu: '附件',
        // 实时投递日志
        sender: '发件账户查询',
        receiver: '收件账户查询',
        sender1: '本地发信失败',

    },
    tan: {
        up: '上传',
        confirm: '确定',
        cancel: '取消',
        confirm1: '添加成功',
        confirm2: '移出成功',
        cancel1: '已取消添加',
        cancel2: '已取消移出',
        tan1: ' 确定加该email为黑名单?加入后，将拒绝来自该email的邮件?',
        tan2: '确定加该email为白名单?加入后，将不对该email过滤！',
        tan3: ' 确定加该ip为黑名单?加入后，将拒绝来自该ip的邮件！',
        tan4: ' 确定加该ip为白名单?加入后，不过滤来自该ip的邮件！',
        tan11: '确定加该email移出黑名单? ',
        tan12: '确定加该email移出白名单? ',
        tan13: '确定加该ip移出黑名单? ',
        tan14: '确定加该ip移出白名单? ',
        bte: '(该Email已被加入黑名单)',
        wte: '(该Email已被加入白名单)',
        bti1: '(该ip已被加入黑名单)',
        wti1: '(该ip已被加入白名单)',
        profile: '确定要配置证书文件吗？',
        config_success: '配置成功',
        reading_pre: '没有阅读权限',
        not_pre: '没有权限',


    }
}